import set from 'lodash/set';
import get from 'lodash/get';
import pick from 'lodash/pick';

import Cookie from 'js-cookie';
import getDomain from 'lib/getDomain.js';

const COOKIE_CONFIG = {
  user: 'gladlyChat-',
  proactiveTriggered: 'gladlyProactive-',
  minimized: 'gladlyChatIsMinimized-',
  minimizedAt: 'gladlyChatLastMinimized-',
  chatLastViewedAt: 'gladlyChatLastViewed-', // for self service
};

export const USER_EXP = 1;
export const MINIMIZED_EXP = 1;
export const MINIMIZED_AT_EXP = 1;
export const CHAT_VIEWED_AT_EXP = 1;

const toUserCookie = user => {
  return pick(user, ['id', 'name', 'email', 'gladlyCustomerId']);
};

export const getCookiePaths = context => {
  let appId = context.config.appId;
  return {
    'ui.isMinimized': { name: `${COOKIE_CONFIG.minimized}${appId}` },
    'ui.minimizedAt': { name: `${COOKIE_CONFIG.minimizedAt}${appId}` },
    'ui.chatLastViewedAt': { name: `${COOKIE_CONFIG.chatLastViewedAt}${appId}` },
    user: { name: `${COOKIE_CONFIG.user}${appId}` },
    'app.proactiveTriggered': { name: `${COOKIE_CONFIG.proactiveTriggered}${appId}` },
  };
};

export const configuredSetCookie = (appId, cookieClient) => {
  const cookieConfig = {
    [`${COOKIE_CONFIG.minimized}${appId}`]: { exp: MINIMIZED_EXP },
    [`${COOKIE_CONFIG.minimizedAt}${appId}`]: { exp: MINIMIZED_AT_EXP },
    [`${COOKIE_CONFIG.chatLastViewedAt}${appId}`]: { exp: CHAT_VIEWED_AT_EXP },
    [`${COOKIE_CONFIG.user}${appId}`]: { exp: USER_EXP, toCookie: toUserCookie },
    [`${COOKIE_CONFIG.proactiveTriggered}${appId}`]: { exp: USER_EXP },
  };
  return (name, value, expires, secure) => {
    expires = expires === undefined ? cookieConfig[name].exp : expires;
    if (cookieConfig[name].toCookie) {
      value = cookieConfig[name].toCookie(value);
    }
    return cookieClient.set(name, JSON.stringify(value), { expires, secure, domain: getDomain() });
  };
};

//Implementation originally from https://github.com/grofers/redux-cookies-middleware
// Refactored to allow for modification of values before they are persisted
// to cookie

const cookiesMiddleware = context => {
  const appId = context.config.appId;
  const paths = getCookiePaths(context);
  const defaultDeleteCheck = value => typeof value === 'undefined';
  const defaultEqualityCheck = (a, b) => a === b;
  const setCookie = configuredSetCookie(appId, Cookie);

  return store => next => action => {
    const prevState = store.getState();
    const result = next(action);
    const nextState = store.getState();

    Object.keys(paths).forEach(pathToState => {
      const prevVal = get(prevState, pathToState);
      const nextVal = get(nextState, pathToState);
      const state = paths[pathToState];
      const equalityCheck = state.equalityCheck || defaultEqualityCheck;
      const deleteCheck = state.deleteCheck || defaultDeleteCheck;

      if (!equalityCheck(prevVal, nextVal)) {
        if (deleteCheck(nextVal)) {
          setCookie(state.name, nextVal, 0);
        } else {
          setCookie(state.name, nextVal);
        }
      }
    });

    return result;
  };
};

export const updateInitialStateFromCookies = (context, initialState) => {
  return getStateFromCookies(initialState, getCookiePaths(context), Cookie.getJSON);
};

export const getStateFromCookies = (preloadedState, paths, getCookie) => {
  Object.keys(paths).forEach(pathToState => {
    const pathConf = paths[pathToState];

    // read cookies
    const storedState = getCookie(pathConf.name);
    if (storedState !== undefined) {
      set(preloadedState, pathToState, storedState);
    }
  });

  return preloadedState;
};

export default cookiesMiddleware;
